import {MAPBOX_TOKEN} from "../../config";
import lightIcon from "../../../public/Light_200by200.png";
import originalIcon from "../../../public/Original_200by200.png";
import satelliteIcon from "../../../public/Terrain_200by200.png";
// import terrainIcon from "../../../assets/Light_200by200.png";


export const styles: {[key: string]: string} = {
    'light': 'mapbox/light-v9',
    'satellite-streets': 'mapbox/satellite-streets-v9',
    'outdoors': 'mapbox/outdoors-v9',
    // 'cono': 'romogis12/cjoudazr29syp2sp0kif3fjid'
};

const mapboxStyles: {[key: string]: string} = {}

export const styleIcons: {[key: string]: string} = {
    'light': lightIcon,
    'satellite-streets': satelliteIcon,
    'outdoors': originalIcon,
    // 'cono': 'Original_200by200.png'
};

Object.keys(styles).forEach(key => {
    mapboxStyles[styles[key]] = styleIcons[key];
})

export const styleKeys = Object.keys(styles).map((key: string) => styles[key]);
export const styleIconsByName = mapboxStyles;
export const getStyleUrl = (styleName: string, token = MAPBOX_TOKEN) =>
    `https://api.mapbox.com/styles/v1/${styleName}` +
    `/?fresh=true&title=true&access_token=${token}` +
    `#2.9/39.98/-97.58`;
